var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7609 7.82285C23.7609 7.82285 23.5266 6.16816 22.8047 5.4416C21.8906 4.48535 20.8688 4.48066 20.4 4.42441C17.0438 4.18066 12.0047 4.18066 12.0047 4.18066H11.9953C11.9953 4.18066 6.95625 4.18066 3.6 4.42441C3.13125 4.48066 2.10938 4.48535 1.19531 5.4416C0.473438 6.16816 0.24375 7.82285 0.24375 7.82285C0.24375 7.82285 0 9.76816 0 11.7088V13.5275C0 15.4682 0.239062 17.4135 0.239062 17.4135C0.239062 17.4135 0.473437 19.0682 1.19062 19.7947C2.10469 20.751 3.30469 20.7182 3.83906 20.8213C5.76094 21.0041 12 21.0604 12 21.0604C12 21.0604 17.0438 21.051 20.4 20.8119C20.8688 20.7557 21.8906 20.751 22.8047 19.7947C23.5266 19.0682 23.7609 17.4135 23.7609 17.4135C23.7609 17.4135 24 15.4729 24 13.5275V11.7088C24 9.76816 23.7609 7.82285 23.7609 7.82285ZM9.52031 15.7354V8.99004L16.0031 12.3744L9.52031 15.7354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.44f57e7efdb5b285f58d390cb125f860.svg";
export { ForwardRef as ReactComponent };